import { registerGtmDataLayer } from '../../../Features/Blocks/Video/gtmDataLayerService';

export class SearchAnalyticsService {
    static trackSearch(query, unfilteredNumberOfHits, searchType = 'intern søgning') {
        const dataLayer = {
            'event': 'track-event',
            'eventCategory': searchType,
            'eventAction': "submit",
            'eventLabel': query,
            'eventValue': unfilteredNumberOfHits,
            'eventNoninteraction': true,
            'searchNumresult': unfilteredNumberOfHits
        };

        registerGtmDataLayer(dataLayer);
    }
}